import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryFurnitureIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-furniture"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M19.2017 10.6144V12.5464C19.2017 13.2851 18.664 13.8842 18.0011 13.8842H5.94211C5.2791 13.8842 4.74151 13.2851 4.74151 12.5464V10.6144C4.74151 9.8702 4.1999 9.26678 3.53206 9.26678H3.20945C2.54151 9.26678 2 9.87 2 10.6144V15.701C2 16.4453 2.54151 17.0487 3.20945 17.0487L3.44834 18.6639C3.48111 18.8853 3.65307 19.048 3.85447 19.048C4.05598 19.048 4.22794 18.8856 4.2607 18.6639L4.4996 17.0487H19.4436L19.6825 18.6639C19.7153 18.8853 19.8872 19.048 20.0887 19.048C20.2901 19.048 20.4621 18.8856 20.4949 18.6639L20.7338 17.0487C21.4017 17.0487 21.9432 16.4453 21.9432 15.701V10.6144C21.9432 9.8702 21.4017 9.26678 20.7338 9.26678H20.4112C19.7433 9.26678 19.2017 9.87 19.2017 10.6144Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M18.1715 5H12.7289C12.4331 5 12.1934 5.2398 12.1934 5.53558V12.934C12.1934 13.2298 12.4331 13.4695 12.7289 13.4695H18.0012C18.4195 13.4695 18.7586 13.1305 18.7586 12.7122V10.4762C18.7586 9.96312 18.9914 9.50161 19.3622 9.19749C19.6758 8.9403 19.8382 8.54211 19.8382 8.13658V6.66653C19.8382 5.74613 19.0921 5 18.1715 5Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M11.2145 13.4696C11.5102 13.4696 11.75 13.2298 11.75 12.934V5.53564C11.75 5.23976 11.5102 5.00006 11.2145 5.00006H5.77176C4.85136 5.00006 4.10522 5.74609 4.10522 6.66659V8.35624C4.10522 8.68277 4.28382 8.9673 4.54241 9.16669C4.93558 9.46991 5.18482 9.94539 5.18482 10.4762V12.7124C5.18482 13.1306 5.52382 13.4696 5.94191 13.4696"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryFurnitureIcon.displayName = 'CategoryFurnitureIcon';
